const allTenancies = (allTenancies = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_TENANCIES':
      return action.payload
    default:
      return allTenancies
  }
}
export default allTenancies
